import React from 'react';
import SimReplacement from 'assets/img/numbers/settings/sim-card-replacement.svg';
import CustomSIMInput from 'components/CustomInput/CustomSIMInput';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/addLineDialogStyle';
import { makeStyles } from '@material-ui/core';
import CustomRadio from 'components/CustomRadio/CustomRadio';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { BodyS } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISimTabProps {
	showError: boolean;
	serialNumber: string;
	helperText: string | undefined;
	setSerialNumber: (e: string) => void;
	setSerialNumberValid: (e: boolean) => void;
	selectedSimType: string;
	setSelectedSimType: React.Dispatch<React.SetStateAction<string>>;
	simTypes: string[];
}

const SimTab = ({
	showError,
	serialNumber,
	helperText,
	setSerialNumber,
	setSerialNumberValid,
	selectedSimType,
	setSelectedSimType,
	simTypes,
}: ISimTabProps) => {
	const classes = useStyles();

	return (
		<div className={classes.smWidth}>
			<div>
				<BodyS>{translate('simtab.choose.sim.type')}</BodyS>
				{simTypes.map((sim, index) => (
					<CustomRadio
						key={index}
						label={sim}
						checked={selectedSimType === sim}
						onChange={() => setSelectedSimType(sim)}
					/>
				))}
			</div>
			<ConditionalRender
				show={selectedSimType === 'SIM'}
				onTrue={() => (
					<div>
						<CustomSIMInput
							labelText={translate('serial.number')}
							formControlProps={{
								fullWidth: true,
							}}
							helperText={helperText}
							supportAsyncValidation={true}
							showError={showError}
							onErrorChange={setSerialNumberValid}
							inputProps={{
								value: serialNumber,
								onChange: (value: string) => setSerialNumber(value),
							}}
						/>
						<img src={SimReplacement} alt="Sim card replacement" className={classes.simReplacementImage} />
					</div>
				)}
			/>
		</div>
	);
};

export default SimTab;
